import { grey } from "@mui/material/colors";

const styles = {
  header: {
    p: 2,
    pb: 1,
    borderBottom: "1px solid #e0e0e0",
  },
  close: {
    color: "black",
    fontSize: 12,
  },
  content: {
    height: "calc(100vh - 120px)",
    overflowY: "auto",
  },
  textSection: {
    pt: 2,
    px: 1,
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 1,
    },
  },
  linkAdornment: {
    fontSize: "0.875rem",
    color: "text.secondary",
    pointerEvents: "none",
  },
  saveButton: {
    mt: 1,
    borderRadius: 1,
    textTransform: "none",
  },
  link: {
    color: "primary.main",
    textDecoration: "none",
    fontWeight: 600,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  accountSection: {
    p: 2,
    border: "1px solid",
    borderColor: "grey.200",
    borderRadius: 1,
    backgroundColor: "grey.50",
  },
  usernameDisplay: {
    py: 1,
  },
  editButton: {
    textTransform: "none",
    borderRadius: 1,
  },
  brandsSection: {
    mt: 2,
  },
  tabContainer: {
    mb: 1,
    borderBottom: `1px solid ${grey[200]}`,
  },
  tab: {
    fontSize: 13,
  },
  selectAll: {
    mb: 1,
    "& .MuiFormControlLabel-root": {
      marginLeft: 0,
    },
  },
  footer: {
    position: "absolute",
    backgroundColor: "white",
    bottom: 0,
    pb: { xs: 0, md: "8px" },
  },
};

export default styles;
